const mutations = {
  saveRoute (state, payload) {
    const { from, to } = payload

    state.from = from.path
    state.to = to.path
  }
}

export default mutations
